import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();

  const redirectToLogin = () => {
    navigate('/machine-management');
  };

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>OOPS！404</h1>
      <h5>File not found「(°ヘ°)</h5>
      <p>這裡空空如也。</p>
      <button
        onClick={redirectToLogin}
        style={{
          backgroundColor: '#F2A365',
          color: 'white',
          padding: '10px 20px',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer',
          marginTop: '20px',
        }}
      >
        返回
      </button>
    </div>
  );
};

export default NotFound;